export const buildCitationFromContentProps = contentProps => ({
  id: contentProps.citationId,
  sourceId: contentProps.sourceId ?? null,
  source: contentProps.sourceShortName ?? contentProps.sourceName ?? '',
  section: contentProps.sectionNumber ?? '',
  title: contentProps.sectionTitle ?? '',
  excerpt: contentProps.excerpt ?? '',
});
